import React from 'react';

const About = () => {
    return (
        <div>
            {/* Breadcrumb Section */}
            <div className="breadcrumb-section breadcrumb-bg">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 offset-lg-2 text-center">
                            <div className="breadcrumb-text">
                                <p></p>
                                <h1>Hakkımızda</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Our Team Section */}
            <div className="mt-150">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 offset-lg-2 text-center">
                            <div className="section-title">
                                <h3>Sayfa <span className="orange-text">Editörlerimiz</span></h3>
                                <p>Editörlerimiz, spor etkinliklerinin analizini değerlendirerek gelecek maçların sonuçları hakkında öngörülerde bulunan uzmanlardır. Analitik yaklaşımlarıyla sporseverlere maç öncesi bilgi sağlarlar.</p>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">

                        {/* <div className="col-lg-4 col-md-6">
                            <div className="single-team-item">
                                <div className="team-bg team-bg-1"></div>
                                <h4>Canlı İddaalıyorum<span>Editör</span></h4>
                                <ul className="social-link-team">
                                    <li><a href="https://x.com/canliiddaali" target="_blank"><i className="fab fa-twitter"></i></a></li>
                                    <li><a href="https://www.instagram.com/canliiddaaliyorum" target="_blank"><i className="fab fa-instagram"></i></a></li>
                                </ul>
                            </div>
                        </div> */}
                        
                        <div className="col-lg-4 col-md-6">
                            <div className="single-team-item">
                                <div className="team-bg team-bg-3"></div>
                                <h4>Allerheiligentor<span>Editör</span></h4>
                                <ul className="social-link-team">
                                    <li><a href="https://x.com/NooBullshittt" target="_blank" rel="noreferrer"><i className="fab fa-twitter"></i></a></li>
                                    <li><a href="https://www.instagram.com/nooobullshitt" target="_blank" rel="noreferrer"><i className="fab fa-instagram"></i></a></li>
                                </ul>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-6">
                            <div className="single-team-item">
                                <div className="team-bg team-bg-jupix8"></div>
                                <h4>JUPIX8<span>Editör</span></h4>
                                <ul className="social-link-team">
                                    <li><a href="https://x.com/blacksun00177" target="_blank" rel="noreferrer"><i className="fab fa-twitter"></i></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* End Our Team Section */}
        </div>
    );
};

export default About;
